import {
  DatagridConfigurable,
  List,
  TextField,
  TopToolbar,
  SelectColumnsButton,
  CreateButton,
  SearchInput,
} from "react-admin";

import { CLIENT_SEARCH_SOURCE } from "@/constants/filters";

const ListActions = () => (
  <TopToolbar>
    <SelectColumnsButton />
    <CreateButton />
  </TopToolbar>
);

export const AccessLevelsList = () => (
  <List
    title="Access Levels"
    actions={<ListActions />}
    filters={[
      <SearchInput
        key="search"
        source={CLIENT_SEARCH_SOURCE}
        placeholder="Search Access Level"
        alwaysOn
      />,
    ]}
    storeKey={false}
    pagination={false}
  >
    <DatagridConfigurable bulkActionButtons={false}>
      <TextField source="title" sortable={false} />
      <TextField source="name" sortable={false} />
      <TextField source="level" sortable={false} />
    </DatagridConfigurable>
  </List>
);
